import { Theme, Grid, Paper, Container } from '@mui/material';
import { createStyles, withStyles } from '@mui/styles';
import { GridColumnVisibilityModel, GridSortDirection, GridSortItem, GridSortModel } from '@mui/x-data-grid';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../setup';
import Pagination from '../../../interfaces/common/pagination';
import IMenuItem from '../../../interfaces/common/menuItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MainLayout from '../../common/widgets/mainLayout';
import LanguageUtils from '../../../utils/LanguageUtils';
import PageUtils from '../../../utils/pageUtils';
import { fetchReportHeader005, getReportHeaders005, resetReportHeader005, isLoadingReportHeaders005 } from '../../../reducers/reportsReducer';
import Paging from '../../../interfaces/common/paging';
import UrlConstants from '../../../constants/UrlConstants';
import ReportHeader005Filters from '../../../interfaces/filters/reportHeader005Filters';
import ReportHeader005List from './reportHeader005List';
import ReportHeader005FilterComponent from './reportHeader005FilterComponent';
import ReportHeader005 from '../../../interfaces/output/ReportHeader005';

interface IReportHeader005Props {
    reportHeader005List: Pagination<ReportHeader005>;
    classes: any;
    fetchReportHeader005: any;
    isLoading: boolean;
    onChange: () => void;
    resetReportHeader005: () => void;
    fetch: any;
}

interface IReportHeader005State {
    filters: ReportHeader005Filters;
    paging: Paging;
    menuItem: IMenuItem;
    sortModel: GridSortModel;
    columnVisibilityModel: GridColumnVisibilityModel;
}

const messages = {
    reportHeader005: LanguageUtils.createMessage('Report Header005')
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchReportHeader005: (paging: Paging, filters: ReportHeader005Filters) => dispatch(fetchReportHeader005({
        paging,
        filters
    })),
    resetReportHeader005: () => dispatch(resetReportHeader005())

});

const mapStoreToProps = (store: RootState) => {
    return {
        reportHeader005List: getReportHeaders005(store),
        isLoading: isLoadingReportHeaders005(store)
    };
};

const styles = (theme: Theme) => createStyles({
    container: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    paper: {
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column'
    }
});

class ReportHeader005Component extends Component<IReportHeader005Props, IReportHeader005State> {
    reportHeader005ListRef: any;
    constructor(props: IReportHeader005Props) {
        super(props);
        this.reportHeader005ListRef = React.createRef();

        this.state = {
            filters: {} as ReportHeader005Filters,
            menuItem: {
                id: 1,
                name: messages.reportHeader005,
                icon: <FontAwesomeIcon icon="warehouse" size="1x" transform="grow-7" />,
                isSelected: false
            },
            paging: PageUtils.getDefaultPaging([{
                field: 'invoiceYear',
                sort: 'desc' as GridSortDirection
            } as GridSortItem,
            {
                field: 'invoiceMonth',
                sort: 'desc' as GridSortDirection
            } as GridSortItem]),
            sortModel: [{
                field: 'invoiceYear',
                sort: 'desc' as GridSortDirection
            } as GridSortItem,
            {
                field: 'invoiceMonth',
                sort: 'desc' as GridSortDirection
            } as GridSortItem],
            columnVisibilityModel: {}
        };
    }

    componentDidMount() {
        const { fetchReportHeader005 } = this.props;
        const { paging, filters } = this.state;

        fetchReportHeader005(paging, filters);
    }

    componentWillUnmount() {
        const { resetReportHeader005 } = this.props;
        resetReportHeader005();
    }

    applyFilters = () => {
        const { fetchReportHeader005 } = this.props;
        const { paging, filters } = this.state;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page
        };
        this.setState({
            paging: newPagination
        });

        fetchReportHeader005(newPagination, filters);

        if(this.reportHeader005ListRef !== null && this.reportHeader005ListRef !== undefined &&
            this.reportHeader005ListRef.current !== null && this.reportHeader005ListRef.current !== undefined) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.reportHeader005ListRef.current.resetDataGridPage();
        }
    }

    onChange = (attribute: string, value: any) => {
        const { filters, paging } = this.state;

        const newFilter = { ...filters } as ReportHeader005Filters;
        (newFilter as any)[attribute] = value;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page
        };

        this.setState({
            filters: newFilter,
            paging: newPagination
        });
    }

    setDefaultState = () => {
        const { fetchReportHeader005 } = this.props;
        const { paging } = this.state;

        const newFilters = {
        } as ReportHeader005Filters;

        const newSortModel = [{
            field: 'invoiceYear',
            sort: 'desc' as GridSortDirection
        } as GridSortItem,
        {
            field: 'invoiceMonth',
            sort: 'desc' as GridSortDirection
        } as GridSortItem] as GridSortModel;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...paging,
            page: newPaging.page,
            sort: newSortModel
        };

        this.setState({
            paging: newPagination,
            filters: newFilters
        });

        fetchReportHeader005(newPagination, newFilters);

        if(this.reportHeader005ListRef !== null && this.reportHeader005ListRef !== undefined &&
            this.reportHeader005ListRef.current !== null && this.reportHeader005ListRef.current !== undefined) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.reportHeader005ListRef.current.resetDataGridPage();
        }
    }

    _onSortChange = (newModel: GridSortModel) => {
        const { fetchReportHeader005 } = this.props;
        const { sortModel, filters, paging } = this.state;

        if(JSON.stringify(sortModel) !== JSON.stringify(newModel)) {
            const newPaging = {
                ...paging,
                sort: newModel
            };

            this.setState({
                sortModel: newModel,
                paging: newPaging
            });

            fetchReportHeader005(newPaging, filters);

        }
    }

    render() {
        const { classes, reportHeader005List, fetchReportHeader005, isLoading } = this.props;
        const { paging, filters, menuItem, columnVisibilityModel } = this.state;

        return (
            <MainLayout
                menuItem={menuItem}
                routes={
                    [{
                        name: 'go to Reports',
                        url: `${UrlConstants.REPORTS}`
                    }]}>
                <Container maxWidth="xl" className={classes.container}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Paper className={classes.paper}>
                                <ReportHeader005FilterComponent
                                    applyFilters={this.applyFilters} setDefaultState={this.setDefaultState} filters={filters} onChange={this.onChange} />
                                <ReportHeader005List rows={reportHeader005List} isLoading={isLoading}
                                    ref={this.reportHeader005ListRef}
                                    onPageChange={(nextPage: number, nextSize: number) => {
                                        const newPage = {
                                            ...paging,
                                            page: nextPage,
                                            size: nextSize
                                        };
                                        fetchReportHeader005(newPage, filters);
                                        this.setState({ paging: newPage });
                                    }}
                                    onSortModelChange={(sortModel: GridSortModel) => this._onSortChange(sortModel)}
                                    columnVisibilityModel={columnVisibilityModel}
                                    onColumnVisibilityModelChange={(newModel: GridColumnVisibilityModel) =>
                                        this.setState({
                                            columnVisibilityModel: newModel
                                        })
                                    }
                                />
                            </Paper>
                        </Grid>
                    </Grid>
                </Container>
            </MainLayout>
        );
    }
}

export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(ReportHeader005Component));